var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 335.45 52.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#3d3327;stroke-linecap:round;stroke-miterlimit:10;stroke-width:14px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "base"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.64,13.24S271.47-14,328.45,45.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7,45.82S46.2-5.81,124.36,19.93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset1);
export default __webpack_public_path__ + "static/media/Asset 1.031531d7.svg";
export { ForwardRef as ReactComponent };